import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  FaUsers,
  FaFileInvoice,
  FaSignOutAlt,
  FaBars,
  FaTimes,
  FaHome,
  FaCalendarAlt,
  FaUser,
  FaClipboardList,
  FaBuilding,
  FaChartBar,
  FaClock,
} from 'react-icons/fa';
import { getAuthUser } from '../utils/auth';

const menuItems = [
  { icon: FaHome, text: 'Dashboard', path: '/home' },
  { icon: FaUsers, text: 'Usuarios', path: '/home/usuarios' },
  { icon: FaCalendarAlt, text: 'Asistencia', path: '/home/asistencia' },
  { icon: FaFileInvoice, text: 'Ajustes', path: '/home/ajustes' },
  { icon: FaClipboardList, text: 'Ausencias', path: '/home/ausencias' },
  { icon: FaClock, text: 'Horas extras', path: '/home/horas-extras' },
  { icon: FaCalendarAlt, text: 'Horarios', path: '/home/horarios' },
  { icon: FaBuilding, text: 'Departamentos', path: '/home/departamentos' },
  { icon: FaUser, text: 'Empleados', path: '/home/empleados' },
];

const reportItems = [
  { icon: FaChartBar, text: 'Presencias', path: '/home/informes/presencias' },
  { icon: FaClipboardList, text: 'Ausencias', path: '/home/informes/ausencias' },
];

function Sidebar({ toggleSidebar, isSidebarOpen, handleLogout }) {
  const authUser = getAuthUser();
  const isEmployee = authUser?.role === 'EMPLOYEE';
  const visibleItems = isEmployee
    ? [
        { icon: FaCalendarAlt, text: 'Asistencia', path: '/home/asistencia' },
        { icon: FaClipboardList, text: 'Ausencias', path: '/home/ausencias' },
        { icon: FaClock, text: 'Horas extras', path: '/home/horas-extras' },
        { icon: FaUser, text: 'Mi perfil', path: '/home/perfil' },
      ]
    : menuItems;

  return (
    <div
      className={`
        bg-gradient-to-b from-blue-700 to-blue-800 text-white h-screen
        ${isSidebarOpen ? 'w-64' : 'w-20'}
        transition-all duration-300 ease-in-out fixed left-0 top-0 z-50
        flex flex-col shadow-lg
      `}
    >
      <div className="p-4 border-b border-blue-700">
        <h2
          className={`
            text-2xl font-bold mb-4
            ${isSidebarOpen ? 'opacity-100' : 'opacity-0'}
            transition-opacity duration-300
          `}
        >
          Presencia
        </h2>
        <button
          onClick={toggleSidebar}
          className={`
            text-white p-2 rounded-lg hover:bg-blue-700 transition-colors duration-200
            focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-50
            flex items-center justify-center
            ${isSidebarOpen ? 'w-10 h-10' : 'w-full'}
          `}
        >
          {isSidebarOpen ? <FaTimes className="h-6 w-6" /> : <FaBars className="h-6 w-6" />}
        </button>
      </div>
      <nav className="flex-grow overflow-y-auto">
        <ul className="space-y-2 p-4">
                    {visibleItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                end
                className={({ isActive }) => `
                  flex items-center p-3 rounded-lg transition-all duration-200 ease-in-out
                  ${isActive ? 'bg-blue-700 text-white' : 'text-blue-100 hover:bg-blue-700 hover:text-white'}
                `}
              >
                <item.icon className={`h-5 w-5 ${isSidebarOpen ? 'mr-3' : 'mx-auto'}`} />
                <span
                  className={`${
                    isSidebarOpen ? 'opacity-100' : 'opacity-0 w-0'
                  } transition-all duration-200`}
                >
                  {item.text}
                </span>
              </NavLink>
            </li>
          ))}
          {!isEmployee && (
            <li>
              <div
                className={`px-3 py-2 text-xs font-semibold uppercase tracking-wider text-blue-100 ${
                  isSidebarOpen ? 'opacity-100' : 'opacity-0 h-0 overflow-hidden'
                }`}
              >
                Informes
              </div>
            </li>
          )}
          {!isEmployee && reportItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                end
                className={({ isActive }) => `
                  flex items-center p-3 rounded-lg transition-all duration-200 ease-in-out
                  ${isActive ? 'bg-blue-700 text-white' : 'text-blue-100 hover:bg-blue-700 hover:text-white'}
                `}
              >
                <item.icon className={`h-5 w-5 ${isSidebarOpen ? 'mr-3' : 'mx-auto'}`} />
                <span
                  className={`${
                    isSidebarOpen ? 'opacity-100' : 'opacity-0 w-0'
                  } transition-all duration-200`}
                >
                  {item.text}
                </span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <div className="p-1 border-t border-blue-700">
        <button
          onClick={handleLogout}
          className="flex items-center w-full p-3 rounded-lg text-red-300 hover:bg-red-600 hover:text-white transition-all duration-200 ease-in-out"
        >
          <FaSignOutAlt className={`h-5 w-5 ${isSidebarOpen ? 'mr-3' : 'mx-auto'}`} />
          <span
            className={`${
              isSidebarOpen ? 'opacity-100' : 'opacity-0 w-0'
            } transition-all duration-200`}
          >
            Cerrar sesion
          </span>
        </button>
      </div>
    </div>
  );
}

export default Sidebar;
